import { ComponentProps } from 'react';
import { tv, VariantProps } from 'tailwind-variants';

import { InputContextProvider } from './input-context';

export const inputRoot = tv({
  base: ['group relative flex items-center gap-2 overflow-hidden rounded-md'],

  variants: {
    size: {
      auto: 'h-auto',
      labeled: 'h-12',
    },
  },

  defaultVariants: {
    size: 'auto',
  },
});

export type RootProps = ComponentProps<'div'> & VariantProps<typeof inputRoot>;

export function Root({ className, size, ...props }: RootProps) {
  return (
    <InputContextProvider>
      <div className={inputRoot({ className, size })} {...props} />
    </InputContextProvider>
  );
}
